import Questionnaire from './Questionnaire.vue';
export default Questionnaire;



// WEBPACK FOOTER //
// ./src/components/parts/questionnaire/index.ts